// Types
import {
  TrackingEventsEnum,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/ziniaweb-ui-core-models';
import { TrackBuilderType } from 'types/track-builder.type';
import {
  ProofIncomeErrorTrackingHandlersReturnType,
  TrackViewHandlerType,
} from './types/proof-income-error.handlers.type';

const trackViewHandler = ({
  errorDescription,
  errorStatus,
  errorNumber,
}: TrackViewHandlerType): TrackingViewEventReturnType => ({
  payload: {
    pageName: '/error/validateTheIncome',
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'page',
    serviceType: 'userSettings',
    errorCategory: 'validateTheIncome',
    errorDescription,
    errorStatus,
    ...(errorNumber ? { errorNumber } : undefined),
  },
  type: TrackingEventsEnum.VIEW,
});

const trackTryAgainHandler = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'click',
    format: 'button',
    component: 'emptyStates',
    element: 'tryAgain',
    eventCategory: 'ProofOfIncomeError',
    eventAction: 'clickButton',
    eventLabel: 'tryAgainButton',
  },
  type: TrackingEventsEnum.LINK,
});

const ProofIncomeErrorTrackingHandlers = (
  track: TrackBuilderType
): ProofIncomeErrorTrackingHandlersReturnType => ({
  handleTrackView: (errorInfo: TrackViewHandlerType) => track(trackViewHandler(errorInfo)),
  handleTrackTryAgain: () => track(trackTryAgainHandler()),
});

export { ProofIncomeErrorTrackingHandlers };
